import * as React from 'react';
import { getId } from 'office-ui-fabric-react/lib/Utilities';
import { ServiceRequest } from "../../Utils/ServiceRequest";
import {
  getTheme,
  mergeStyleSets,
  FontWeights,
  ContextualMenu,
  //Checkbox,
  //DefaultButton,
  Modal,
  IDragOptions,
  IconButton
} from 'office-ui-fabric-react';


import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { FontSizes } from '@uifabric/styling';

//import { first } from 'lodash';
import { Dropdown, 
  //DropdownMenuItemType, 
  IDropdownOption } 
from 'office-ui-fabric-react/lib/Dropdown';
import {ListCategory,MSListConfig,MSListFiled} from '../../Entity/MySettingobj';
import MIPACheckBox from '../Common/MIPACheckBox';
export interface IProps {
    closeMethod;
    phrases;
    APIServiceurl;
    APIHeader;    
    UserEmail;
    UserSiteURL;
    CategoryList:Array<ListCategory>;
    ListInfo:MSListConfig;
  }

const theme = getTheme();
const contentStyles = mergeStyleSets({
  container: {
    display: 'flex',
    flexFlow: 'column nowrap',
    alignItems: 'stretch'
  },
  header: [
    // tslint:disable-next-line:deprecation
    theme.fonts['xLargePlus'],
    {
      flex: '1 1 auto',
      borderTop: `4px solid ${theme.palette.themePrimary}`,
      color: theme.palette.neutralPrimary,
      display: 'flex',
      fontSize: FontSizes.xLarge,
      alignItems: 'center',
      fontWeight: FontWeights.semibold,
      padding: '12px 12px 14px 24px'
    }
  ],
  body: {
    flex: '4 4 auto',
    padding: '0 24px 24px 24px',
    overflowY: 'hidden',
    selectors: {
      p: {
        margin: '14px 0'
      },
      'p:first-child': {
        marginTop: 0
      },
      'p:last-child': {
        marginBottom: 0
      }
    }
  }
});

const iconButtonStyles = mergeStyleSets({
  root: {
    color: theme.palette.neutralPrimary,
    marginLeft: 'auto',
    marginTop: '4px',
    marginRight: '2px'
  },
  rootHovered: {
    color: theme.palette.neutralDark
  }
});
export default class NewMysetting extends React.Component<IProps> {  
    private _titleId: string = getId('title');
    private _subtitleId: string = getId('subText');
    private _dragOptions: IDragOptions = {
                                            moveMenuItemText: 'Move',
                                            closeMenuItemText: 'Close',
                                            menu: ContextualMenu
                                        };
   
    private FromValidationMessages=[];
    public SRequest = new ServiceRequest();
    public state={
      isLoading:false
    };
        public ListFields=[];
       public choicevalue=[];     
    /*
    public SiteURl:string='';
    public ListTitle:string='';

    public dateselectedvalue=''
    public userselectdvalue='';
    public statusselectedvalue='';
    public operatorselected='';
    public choiceselected='';

    public SelectedFields=[];
    */
    public newListInformation:MSListConfig;
    constructor(props) {
        super(props);    
        if(this.props.ListInfo && this.props.ListInfo.ListTitle!=''){
          //this.ListTitle=this.props.ListInfo.ListTitle;
          //this.SiteURl=this.props.ListInfo.SiteURL;
          this.newListInformation=this.props.ListInfo;
          if(this.props.ListInfo.AllFields!=null && this.props.ListInfo.AllFields.length>0){
            this.ListFields=this.props.ListInfo.AllFields;
            this.PrepareFlagChoice(this.props.ListInfo.FlagField.Name);
          }else{
            this.LoadListInformation();
          }
        }else{
          this.newListInformation=new MSListConfig();
        }  
        }
    public render() {
      let fieldRow=null;
      let dropdowndate=null,dropdowanuser=null,dropdownstatus=null,operator=null,dropdownCategory=null;
      
      if(this.ListFields.length>0){
        fieldRow=[];
        dropdowndate=[];
        dropdowanuser=[];
        
        dropdownstatus=[];
        dropdownCategory=[];
        if(this.props.CategoryList!=null && this.props.CategoryList.length>0){
          this.props.CategoryList.map((cat)=>{
            dropdownCategory.push({key:cat.ID,text:cat.CategoryName});
          });
        }
        operator=[
          {key:'Eq',text:'Equal'},
          {key:'Neq',text:'Not equal'}
        ];
        this.ListFields.map((field=>{
          if(field.Type== "DateTime"){
            dropdowndate.push({key:field.Name,text:field.Title});
          }
          else  if(field.Type== "User"){
            dropdowanuser.push({key:field.Name,text:field.Title});
          }
          else  if(field.Type== "Choice"){
            dropdownstatus.push({key:field.Name,text:field.Title,Choices:field.Choices});

            /* if(choicevalue.length==0 && field.Choices){
              field.Choices.forEach(p=>{
                choicevalue.push({key:p,text:p});
              });
            } */
          }
          
          let isCardCheck=false;
          let isDetailsCheck=false;
          let sequenceval=0;
          if(this.newListInformation.DisplayFields!=null && this.newListInformation.DisplayFields.length>0){
            let tempfield=this.newListInformation.DisplayFields.filter(item => item.Name == field.Name);
            if(tempfield!=null && tempfield.length>0){
              isCardCheck=tempfield[0].ShowInCard;
              isDetailsCheck=tempfield[0].ShowInDetails;
              sequenceval=tempfield[0].Sequence
            }
          }
          //fieldRow.push(<div className="ms-Grid-col ms-sm2" style={{marginTop:8}}>
          let row=(<div key={"viewfieldrow"+field.Name} className='ms-Grid-row' style={{padding:5,borderBottom:'1px solid #eee'}}>
          <div className='ms-Grid-col ms-sm4 ms-md4 ms-lg4'>
          {field.Title}
          </div>
          <div className='ms-Grid-col ms-sm2 ms-md2 ms-lg2'>
          {field.Type}
          </div>
          <div className='ms-Grid-col ms-sm2 ms-md2 ms-lg2'>
          <MIPACheckBox
          key={"viewcard"+field.Name}
              label={''}
              defaultChecked={isCardCheck}
              onChange={(ev: React.FormEvent<HTMLElement>, isChecked: boolean) => {
                let addedfiled=this.newListInformation.DisplayFields.filter(item => item.Name == field.Name);
                if(addedfiled!=null && addedfiled.length>0){
                  if(isChecked){
                    addedfiled[0].ShowInCard=true;
                    return;
                  }else if( addedfiled[0].ShowInDetails){
                    addedfiled[0].ShowInCard=false;
                    return;
                  }
                }
                if(isChecked){
                  let tempfiled:MSListFiled={...field};
                  tempfiled.ShowInCard=true;
                  this.newListInformation.DisplayFields.push(tempfiled);
                }else{
                  this.newListInformation.DisplayFields=this.newListInformation.DisplayFields.filter(item => item.Name != field.Name);
                }
              }}
          />
          </div>
          <div className='ms-Grid-col ms-sm2 ms-md2 ms-lg2'>
          <MIPACheckBox
          key={"viewdetails"+field.Name}
          label={''}
              defaultChecked={isDetailsCheck}
              onChange={(ev: React.FormEvent<HTMLElement>, isChecked: boolean) => {
                let addedfiled=this.newListInformation.DisplayFields.filter(item => item.Name == field.Name);
                if(addedfiled!=null && addedfiled.length>0){
                  if(isChecked){
                    addedfiled[0].ShowInDetails=true;
                    return;
                  }else if( addedfiled[0].ShowInCard){
                    addedfiled[0].ShowInDetails=false;
                    return;
                  }
                }
                if(isChecked){
                  let tempfiled:MSListFiled={...field};
                  tempfiled.ShowInDetails=true;
                  this.newListInformation.DisplayFields.push(tempfiled);
                }else{
                  this.newListInformation.DisplayFields=this.newListInformation.DisplayFields.filter(item => item.Name != field.Name);
                }
              }}
          />
          </div>
          <div className='ms-Grid-col ms-sm2 ms-md2 ms-lg2'>
          <TextField key={"viewsequence"+field.Name}
                    type="number" 
                        onChange={(event)=>{
                          if(event.target["value"]==''){
                            return;
                          }
                          //this.newListInformation.SiteURL=event.target["value"];
                          let tempfiled:MSListFiled={...field};
                          let addedfiled=this.newListInformation.DisplayFields.filter(item => item.Name == field.Name);
                          if(addedfiled!=null && addedfiled.length>0){
                            addedfiled[0].Sequence=parseInt(event.target["value"]);
                          }else{
                            tempfiled.Sequence=parseInt(event.target["value"]) ;
                            tempfiled.ShowInDetails=false;
                            tempfiled.ShowInCard=false;
                            this.newListInformation.DisplayFields.push(tempfiled);
                          }
                          this.setState({ chagnevalue:new Date() });
                  
                        }}  
                        value={sequenceval.toString()}
                        //label="Site URL"
                        //placeholder="Site URL"
                    />      
          </div>
        </div>);
        fieldRow.push(row);
          
      //</div>); 
        }));
        
      }
    return (
            <div>         
              <Modal
                titleAriaId={this._titleId}
                subtitleAriaId={this._subtitleId}
                isOpen={true}
                onDismiss={()=>{this.props.closeMethod(false)}}
                isBlocking={true}
                containerClassName={contentStyles.container}
                dragOptions={this._dragOptions}
              >
              <div className={contentStyles.header}>
              <span id={this._titleId}>List Configuration</span>
             
              <IconButton
                styles={iconButtonStyles}
                iconProps={{ iconName: 'Cancel' }}
                ariaLabel="Close popup modal"
                onClick={()=>{this.props.closeMethod(false)}}
              />
              {this.state.isLoading?(
                <div className="mipaloading">&nbsp;</div>
              ):null}
              
              </div>
              
              <div id={this._subtitleId} className={contentStyles.body} style={{minHeight:'70vh',minWidth:'70vw',maxHeight:'80vh',overflow:'auto'}}>
              <div className="ms-Grid-row">                  
                  <div className="ms-Grid-col ms-sm12 ms-md5 ms-lg5">
                    <TextField
                    type="url" 
                        onChange={(event)=>{
                          this.newListInformation.SiteURL=event.target["value"];
                          this.setState({ chagnevalue:new Date() });
                        }}  
                        value={this.newListInformation.SiteURL}
                        label="Site URL"
                        placeholder="Site URL"
                    />                        
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-md5 ms-lg5">
                    <TextField 
                        onChange={(event)=>{
                          this.newListInformation.ListTitle=event.target["value"];
                          this.setState({ chagnevalue:new Date() });
                        }}  
                        value={this.newListInformation.ListTitle}
                        label="List Title"
                        placeholder="List Title" />                        
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-md2 ms-lg2 formbuttoncell">
                  <button onClick={this.LoadListInformation} className="ms-Button ms-Button--default viewswitchbtn plannertask">
                        Load list info
                      </button>                       
                  </div>
              </div>
              {this.ListFields.length>0?(
                <div>
                  
                  <div className='ms-Grid' style={{margin:8}}>
                    <div className='ms-Grid-row' style={{background: '#eee',padding: '8px'}}>
                      <div className='ms-Grid-col ms-sm4 ms-md4 ms-lg4'>
                          Field Name
                      </div>
                      <div className='ms-Grid-col ms-sm2 ms-md2 ms-lg2'>
                          Type
                      </div>
                      <div className='ms-Grid-col ms-sm2 ms-md2 ms-lg2'>
                          Show in Card
                      </div>
                      <div className='ms-Grid-col ms-sm2 ms-md2 ms-lg2'>
                          Show in Details
                      </div>
                      <div className='ms-Grid-col ms-sm2 ms-md2 ms-lg2'>
                          Sequence
                      </div>
                    </div>
                    {fieldRow}
                  </div>
                 
                  
                  <div className="ms-Grid-row">
                          <div className="ms-Grid-col ms-sm4 ms-md4 ms-lg4">
                                <Dropdown
                                              label={'Date Field'}
                                              selectedKey={this.newListInformation.DateField.Name}
                                              onChange={(event: React.FormEvent<HTMLDivElement>, item)=>{
                                                this.newListInformation.DateField=new MSListFiled();
                                                this.newListInformation.DateField.Name=item.key.toString();
                                                this.setState({changed:true});
                                              }}
                                              placeholder={'select date field'}
                                              options={dropdowndate}
                                              styles={{ dropdown: { width: '100%' } }}
                                          />
                            </div> 
                            <div className="ms-Grid-col ms-sm4 ms-md4 ms-lg4">
                                      <Dropdown
                                          label={'User Field'}
                                          selectedKey={this.newListInformation.UserField.Name}
                                          onChange={(event: React.FormEvent<HTMLDivElement>, item)=>{
                                            this.newListInformation.UserField=new MSListFiled();
                                            this.newListInformation.UserField.Name=item.key.toString();
                                            this.setState({changed:true});
                                          }}
                                          placeholder={'select user field'}
                                          options={dropdowanuser}
                                          styles={{ dropdown: { width: '100%' } }}
                                      />
                              </div> 
                                <div className="ms-Grid-col ms-sm4 ms-md4 ms-lg4">
                                          <Dropdown
                                              label={'Category'}
                                              selectedKey={this.newListInformation.CategoryId}
                                              onChange={(event: React.FormEvent<HTMLDivElement>, item)=>{
                                                this.newListInformation.CategoryId=item.key.toString();
                                                this.setState({changed:true});
                                              }}
                                              placeholder={'select category'}
                                              options={dropdownCategory}
                                              styles={{ dropdown: { width: '100%' } }}
                                          />
                                  </div>                   
                          </div> 
                  <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm4 ms-md4 ms-lg4">
                              <Dropdown
                                            label={'status'}
                                            selectedKey={this.newListInformation.FlagField.Name}
                                            onChange={(event: React.FormEvent<HTMLDivElement>, item: IDropdownOption)=>{                                              
                                              this.newListInformation.FlagField.Name=item.key.toString();
                                              this.newListInformation.FlagField.Value='';
                                              this.PrepareFlagChoice(item.key);                                           
                                              this.setState({changed:true});
                                            }}
                                            placeholder={'select status field'}
                                            options={dropdownstatus}
                                            styles={{ dropdown: { width: '100%' } }}
                                        />
                        </div>
                        <div className="ms-Grid-col ms-sm4 ms-md4 ms-lg4">
                              <Dropdown
                                            label={'operator'}
                                            selectedKey={this.newListInformation.FlagField.Operator}
                                            onChange={(event: React.FormEvent<HTMLDivElement>, item)=>{
                                              this.newListInformation.FlagField.Operator=item.key.toString();
                                              this.setState({changed:true});
                                            }}
                                            placeholder={'select user field'}
                                            options={operator}
                                            styles={{ dropdown: { width: '100%' } }}
                                        />
                        </div>
                        <div className="ms-Grid-col ms-sm4 ms-md4 ms-lg4">
                        <Dropdown
                                      label={'status value'}
                                      selectedKey={this.newListInformation.FlagField.Value}
                                      onChange={(event: React.FormEvent<HTMLDivElement>, item)=>{                                        
                                        this.newListInformation.FlagField.Value=item.key.toString();
                                        this.setState({changed:true});
                                      }}
                                      placeholder={'select status value'}
                                      options={this.choicevalue}
                                      styles={{ dropdown: { width: '100%' } }}
                                  />
                        </div>
                  </div>
                    
                  
                </div>
              
              ):null }
              
              <div className="ms-Grid-row">
                 <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 notebox">
                   <ul className="error">
                     {this.FromValidationMessages}
                   </ul>
                   
                 </div>
              </div>
              {this.ListFields.length>0?(
                <div className="ms-Grid-row">
                  <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                      <div className="buttonarea">
                      <button onClick={this.SaveListInformation} className="ms-Button ms-Button--default viewswitchbtn plannertask">
                        {this.props.phrases.save}
                      </button>
                      <button 
                        className="ms-Button ms-Button--default viewswitchbtn"
                        onClick={()=>{this.props.closeMethod(false)}}
                      >
                        {this.props.phrases.cancel}
                      </button>
                      </div>
                    
                  </div>
              </div>
              ):null}
              
              </div>
              </Modal>
            </div>
            );
  }
  private LoadListInformation=()=>{
    this.FromValidationMessages=[];
    if(this.newListInformation.ListTitle=='' || this.newListInformation.ListTitle==null){
      this.FromValidationMessages.push(<li>Please provide List Title</li>);
    }
    if(this.newListInformation.SiteURL=='' || this.newListInformation.SiteURL==null){
      this.FromValidationMessages.push(<li>Please provide site url</li>);
    }
    if(this.FromValidationMessages.length>0){
      this.setState({changeed:true});
      return;
    }
    var api =
    "/GetMicrosoftListInformation";
    let objRequest={
      ListTitle:this.newListInformation.ListTitle,
      SiteURL:this.newListInformation.SiteURL,
      UserEmail:this.props.UserEmail
    };
    let message="Please provide valid sharepoint site URL and List title";
  this.SRequest.Post(
    this.props.APIServiceurl,
    api,
    objRequest,
    (successres)=>{
     if(successres && successres.data && successres.data.IsSuccess){
        this.ListFields=successres.data.data;
        this.newListInformation.AllFields=this.ListFields;
        if(this.props.ListInfo.FlagField!=null && this.props.ListInfo.FlagField.Name!=null && this.props.ListInfo.FlagField.Name!=''){
          this.PrepareFlagChoice(this.props.ListInfo.FlagField.Name);
        }
        this.setState({changed:true});
     }else{
      this.FromValidationMessages=[];
      //this.FromValidationMessages.push(<li>Error occurd try again {successres.data.Message}</li>);
      this.FromValidationMessages.push(<li>Error occurd, {message} </li>);
      this.setState({changed:true});
     }
    },
    (errorres)=>{
      //this.ShowHideProgress(-1);
      this.FromValidationMessages=[];
      
      this.FromValidationMessages.push(<li>Error occurd, {message} </li>);
      this.setState({changed:true});
      console.log(errorres);
    },
    this.ShowHideProgress,
    this.props.APIHeader
  );
  }
  private ShowHideProgress = value => {
    if (value <= 0) {
      this.setState({ isLoading: false });
    } else  {      
      this.setState({ isLoading: true });
    }
  }
  private SaveListInformation=()=>{
    this.FromValidationMessages=[];
    if(this.newListInformation.ListTitle=='' || this.newListInformation.ListTitle==null){
      this.FromValidationMessages.push(<li>Please provide List Title</li>);
    }
    if(this.newListInformation.SiteURL=='' || this.newListInformation.SiteURL==null){
      this.FromValidationMessages.push(<li>Please provide site url</li>);
    }
    if(this.newListInformation.DateField==null || this.newListInformation.DateField.Name==null || this.newListInformation.DateField.Name==''){
      this.FromValidationMessages.push(<li>Please select date field</li>);
    }
    if(this.newListInformation.UserField==null || this.newListInformation.UserField.Name==null || this.newListInformation.UserField.Name==''){
      this.FromValidationMessages.push(<li>Please select user field</li>);
    }
    if(this.newListInformation.FlagField==null || this.newListInformation.FlagField.Operator==null || this.newListInformation.FlagField.Operator==''){
      this.FromValidationMessages.push(<li>Please select operator field</li>);
    }
    if(this.newListInformation.FlagField==null || this.newListInformation.FlagField.Value==null || this.newListInformation.FlagField.Value==''){
      this.FromValidationMessages.push(<li>Please select status value</li>);
    }
    if(this.newListInformation.FlagField==null || this.newListInformation.FlagField.Name==null || this.newListInformation.FlagField.Name==''){
      this.FromValidationMessages.push(<li>Please select status field</li>);
    }
    if(this.newListInformation.CategoryId==null ||  this.newListInformation.CategoryId==''){
      this.FromValidationMessages.push(<li>Please select category field</li>);
    }

    if(this.FromValidationMessages.length>0){
      this.setState({changeed:true});
      return;
    }

    var api =
    "/SaveMIPAListInformation";
   
    let configobj={
      //ListTitle:this.ListTitle,
      SiteURL:this.props.UserSiteURL,
      UserEmail:this.props.UserEmail
    };
   var objRequest={
    config:configobj,
    listinfo:this.newListInformation
   };
  this.SRequest.Post(
    this.props.APIServiceurl,
    api,
    objRequest,
    (successres)=>{
     if(successres && successres.data && successres.data.IsSuccess){
      //console.log(successres.data);
      this.props.closeMethod(false,successres.data.data);
     }
    },
    (errorres)=>{
      this.FromValidationMessages.push(<li>Error occurd, {errorres} </li>);
      this.setState({changed:true});
      console.log(errorres);
    },
    this.ShowHideProgress,
    this.props.APIHeader
  );
  }
  private  PrepareFlagChoice=(fieldname)=>{
    if(fieldname && fieldname!=''){
      let item=this.ListFields.filter(f=>f.Name==fieldname)[0];
      this.choicevalue=[];
      item['Choices'].forEach(p=>{
      this.choicevalue.push({key:p,text:p});
    });
    }
  }
}
